import { basename } from "path";

class Base{
    Code: string;
    Header: string;
    Title: string;
    Message: string;

    constructor(code: string, header: string, title: string, message: string){
        this.Code = code;
        this.Header = header;
        this.Title = title;
        this.Message = message;
    }
}

export class OrderStatus{
    static OrderReceived = new Base("O", "Order Created", "Ordering", "Order Created");
    static CustomerCancelOrder = new Base("X", "Customer cancellation", "Customer cancellation", "Customer cancellation");
    static OrderInProcess = new Base("K", "Order in process", "Processing", "Order in process");
    static OrderOnHold = new Base("W", "Order on hold", "Processing", "Order in process");
    static PartialOrderInProcess = new Base("B", "Partial order in process", "Processing", "Order in process");
    static OrderSDBlock = new Base("Q", "Order SD Block", "Order SD Block", "Order SD Block");
    static DeliveryInTransit = new Base("S", "Delivery in transit", "Delivery", "Delivery in transit");
    static CustomerConfirmedOrder = new Base("D", "Customer Confirmed Receipt", "Customer confirmation", "Customer confirmed receipt");
    static CustomerConfirmedRejection = new Base("R", "Confirmed Rejection", "Confirmed Rejection", "Confirmed Rejection");
    static CustomerConfirmedReceiptOrRejection = new Base("R", "Order Partially Delivered", "Order Partially Delivered", "Order Partially Delivered");
    static OrderPartialDeliver = new Base("M", "Order Partially Delivered", "Order Partially Delivered", "Order Partially Delivered");
}


// WEBPACK FOOTER //
// ./src/services/order-status.ts